/* import libraries */
import { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';

/* import components */
import Container from 'react-bootstrap/Container';
import Menu from "../components/Menu";
import TripCard from '../components/TripCard';

/* import services */
import tripsApi from '../api/tripsApi';
  
const TripHistory = () => {
    const { state } = useLocation();
    const [trips, setTrips] = useState(state.tripsData);
    const [currPage, setCurrPage] = useState(2);
    const [hasMore, setHasMore] = useState(true);

    const getAllTrips = async (page) => {
      try {
        const response = await tripsApi.getTripsWithin30Days({ perPage: 10, page: page });
        setCurrPage(currPage+1);
        if (response.status) {  
          setTrips([...trips, ...response.data.data]);
          if (response.data.data.length < 10) {
            setHasMore(false);
          }
        } else {
          console.error(response.error.msg);
        }
      } catch (error) {
        console.error("Error while fetching trips: " + error.message)
      }
    }

    return (
      <>  
        <Menu title="RydeHELP" />
        <Container style={{ paddingTop: "20px"}}>
            <div className="grey font-bold" style={{ fontSize:"16px"}}>
              Trip History (Past 30 Days)
            </div>
            <InfiniteScroll 
              dataLength={currPage * 10}
              next={() => getAllTrips(currPage)} 
              hasMore={hasMore} 
              loader={<h6>Loading...</h6>}
            >
              {trips.map((trip,i) => 
                <Link 
                  key={i} 
                  to={`/trip/${trip.id}`} 
                  state={{ trip }} 
                  style={{ textDecoration: "none"}}>
                    <TripCard key={trip.id} trip={trip} showChevron={true}/>
                </Link>)
              }
            </InfiniteScroll>
        </Container>
      </>
      );
  }

  export default TripHistory;